import List from '../modules/quote_table/list'

var data = {
    icon:{
        '000001':'icon_cn',
        '399001':'icon_cn',
        '399006':'icon_cn',
        'DJIA':'icon_usa',
        'NDX':'icon_usa',
        'HSI':'icon_hkg',
        'N225':'icon_jpn',
        'FTSE':'icon_gbr',
        'GC00Y':'icon_gold',
        'CL00Y':'icon_nymex',
        'USDCNH':'icon_usdcnh',
        'UDI':'icon_usa',
        'SPX':'icon_usa',
        'GDAXI':'icon_ger',
        'FCHI':'icon_far',
        'HSCEI':'icon_cn',
        'HSAHP':'icon_hkg',
        'TWII':'icon_cn',
        'STI':'icon_sin',
        'BC':'icon_nymex',
        'CRB':'icon_usa',
        'BDI':'icon_gbr',
        'EURUSD':'icon_eurusd',
        'USDJPY':'icon_usdjpy',
        'GBPUSD':'icon_gbpusd',
        'AUDUSD':'icon_audusd',
        'USDCHF':'icon_usdchf',
        'USDCNYC':'icon_usdcnh',
        'JPYCNYC':'icon_jpycnyc',
        'EURCNYC':'icon_eurcnyc',
        'HKDCNYC':'icon_hkdcnyv',
        'GBPCNYC':'icon_gbpcnyc',
        '040120':'icon_cn',
        '040130':'icon_cn',
        '060120':'icon_cn',
        '060130':'icon_cn',
        '070120':'icon_cn',
        '070130':'icon_cn',
        'CN00Y':'icon_sin',
        'YM00Y':'icon_usa',
        'ES00Y':'icon_usa',
        'NQ00Y':'icon_usa',
        'HSI_M':'icon_hkg'
    },
    init:function(){
        let self = this
        self.makeList1()
        self.makeList2()
        self.makeList3()
        self.makeList4()
        self.makeList5()
        self.makeList6()
        self.makeList7()
        self.makeList8()
        self.makeList9()
        self.bindFun()
        setInterval(function(){
          self.makeList9()
        },15000)
    },
    bindFun:function(){
      let self = this
      let win: any = window
      $('#qqzq').click(function(){
        try {
          let win: any = window
          win.layer.open({
            content: `<div style="color:white">该品种暂无走势分析</div>`
            ,skin: 'msg'
            ,time: 2 //2秒后自动关闭
          })
        } catch (error) {
          
        }
      })
      $('#appgo-omzs').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040600001"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=811&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
      })
      $('#appgo-ytzs').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040600002"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=865&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
      })
      $('#appgo-gnqz').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040600003"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=866&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
      })
      $('#appgo-whsc').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040700002"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=867&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
      })
      $('#appgo-rmbzjj').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040700003"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=868&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
      })
      $('#appgo-qqqz').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040700001"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=827&h5url=https%3a%2f%2fvipmoney.eastmoney.com%2fCrumbs%2fContent%2fqqqz%2fINDEX.HTML%3ffrom%3dgroupmessage%26pkg%3ddfcf&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
        // if(self.isIOS()){
        //   window.location.href = 'https://emh5wap.eastmoney.com/h52n/CommScheme?linktype=827&h5url=https%3a%2f%2fvipmoney.eastmoney.com%2fCrumbs%2fContent%2fqqqz%2fINDEX.HTML%3ffrom%3dgroupmessage%26pkg%3ddfcf'
        // }else{
        //   window.location.href = 'https://vipmoney.eastmoney.com/Crumbs/Content/qqqz/INDEX.HTML?from=groupmessage&pkg=dfcf'
        // }
      })
      $('#appgo-qqzq').click(function(){
        try {
          if(win.sendTrackLog){
            win.sendTrackLog('div','click','other.click','{"adID":"2021040700004"}')
          }
        } catch (error) {
            
        }
        window.location.href = 'https://emstatic.eastmoney.com/awaken/app/share.html?linktype=827&h5url=https%3a%2f%2fvipmoney.eastmoney.com%2fcollect%2fmin%2fgovt_bonds%2findex.html&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0004317a'
        // if(self.isIOS()){
        //   window.location.href = 'https://emh5wap.eastmoney.com/h52n/CommScheme?linktype=827&h5url=https%3a%2f%2fvipmoney.eastmoney.com%2fcollect%2fmin%2fgovt_bonds%2findex.html'
        // }else{
        //   window.location.href = 'https://vipmoney.eastmoney.com/collect/min/govt_bonds/index.html'
        // }
      })
    },
    makeList1:function(){
        let self = this
        let List1 = new List({
            ele:'cyzs',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=1.000001,0.399001,0.399006,100.DJIA,100.NDX,100.HSI,100.N225,100.FTSE,101.GC00Y,102.CL00Y,133.USDCNH,100.UDI&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List1.init()
    },
    makeList2:function(){
        let self = this
        let List2 = new List({
            ele:'omzs',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=100.DJIA,100.NDX,100.SPX,100.FTSE,100.GDAXI,100.FCHI&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List2.init()
    },
    makeList3:function(){
        let self = this
        let List3 = new List({
            ele:'ytzs',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=100.HSI,100.HSCEI,100.HSAHP,100.TWII,100.N225,100.STI&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List3.init()
    },
    makeList4:function(){
        let self = this
        let List4 = new List({
            ele:'dzsp',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=101.GC00Y,102.CL00Y,112.BC,100.CRB,100.BDI&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List4.init()
    },
    makeList5:function(){
        let self = this
        let List5 = new List({
            ele:'whsc',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=119.EURUSD,119.USDJPY,119.GBPUSD,119.AUDUSD,119.USDCHF&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List5.init()
    },
    makeList6:function(){
        let self = this
        let List6 = new List({
            ele:'rmbzjj',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=120.USDCNYC,120.JPYCNYC,120.EURCNYC,120.HKDCNYC,120.GBPCNYC&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List6.init()
    },
    makeList7:function(){
        let self = this
        let List7 = new List({
            ele:'gnqz',
            api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=8.040120,8.040130,8.060120,8.060130,8.070120,8.070130&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List7.init()
    },
    makeList8:function(){
      let self = this
      let List8 = new List({
          ele:'qqqz',
          api:'//push2.eastmoney.com/api/qt/ulist.np/get?cb=?&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=104.CN00Y,103.YM00Y,103.ES00Y,103.NQ00Y,134.HSI_M&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
          refresh: 15,
          html:function(data){
              return `
              <dd>
                  <a href="/quote/stock/${data.f13}.${data.f12}.html">
                      <div>
                          <p style=${data.f14.length>6?'font-size:1.3rem':''}><i class=${self.icon[data.f12]}></i>${data.f14}</p>
                      </div>
                      <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                      <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                  </a>
              </dd>
              `
          }
      })
      List8.init()
    },
    makeList9:function(){
      let self = this
      $.ajax({
          url: '/quote/api/global/qqzq',
          type: 'get',
          dataType: 'json',
          success:function(json){
              let list = ''
              json.forEach((item) => {
                let icon = item.code.indexOf("CN") > -1 ? "icon_cn":"icon_usa"
                list += `<dd>
                            <a href="javascript:void(0);">
                                <div>
                                    <i class="${icon}"></i>
                                    <div>
                                      <p style='font-size:1.6rem'}>${item.data.name}</p>
                                      <p style="">${self.timeProcess(item.data.date, item.data.time)}${" | 债券收益率"}</p>
                                    </div>
                                </div>
                                <div class=${Number(item.data.percent) > 0 ? 'shares-rise' : (Number(item.data.percent) < 0 ? 'shares-fall' : '')}>${self.numberFix(item.data.price,3)}</div>
                                <div class=${Number(item.data.percent) > 0 ? 'shares-rise' : (Number(item.data.percent) < 0 ? 'shares-fall' : '')}>${self.dataProcess(Number(item.data.percent),'%')}</div>
                            </a>
                        </dd>`
              });
              let html = `<dl>${list}</dl>`
              $('#qqzq').html(html)
          },
          error:function(){

          }
      })
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = '+'
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
          return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
          return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
          return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
          return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2)
          }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1)
          }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0)
          }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
          }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
          }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
          }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
          }
        } else if (Math.abs(num) >= 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
          }
        }else{
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,2) + symbol
        }
    },
    isIOS:function(){
      var userAgentInfo = navigator.userAgent,
          Agents = ["iPhone", "iPad", "iPod"];
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
              return true;
          }
      }
      return false;
    },
    timeProcess:function(date, time){
      let thisdate = new Date();
      let y = thisdate.getFullYear();
      let m = thisdate.getMonth() + 1;
      let d = thisdate.getDate();

      if(time.length == 4) time = '00' + time
      if(time.length == 5) time = '0' + time
      
      
      let _date = new Date(date.substring(0, 4), date.substring(4, 6) - 1, date.substring(6, 8), time.substring(0, 2), time.substring(2, 4), time.substring(4, 6));
      let _y = _date.getFullYear();
      let _m = _date.getMonth() + 1;
      let _d = _date.getDate();
      let _h = (_date.getHours() < 10 ? ('0' + _date.getHours()) : _date.getHours()) + ':';
	    let _min = (_date.getMinutes() < 10 ? ('0' + _date.getMinutes()) : _date.getMinutes()) + ':';
	    let _s = (_date.getSeconds() < 10 ? ('0' + _date.getSeconds()) : _date.getSeconds());
      let __m = _m < 10 ? ('0' + _m) : _m
      let __d = _d < 10 ? ('0' + _d) : _d

      let result = ''

      if(y == _y){
        if(m == _m && d == _d){
          // 时间戳为当天的
          result = _h + _min + _s
        }else{
          result = __m + '/' + __d
        }
      }else{
        result = _y + '/' + __m + '/' + __d
      }
      return result
    }
}

data.init()